// components/receptionist/AssignDoctorModal.jsx
import React from "react";

const AssignDoctorModal = ({
  show,
  onHide,
  doctors,
  assignData,
  setAssignData,
  onAssign,
  loading,
}) => {
  if (!show) return null;

  const getPriorityColor = (priority) => {
    const colors = {
      "Most Urgent": "#dc3545",
      Urgent: "#ffc107",
      Normal: "#17a2b8",
    };
    return colors[priority] || colors.Normal;
  };

  return (
    <div
      className="modal show d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content"
          style={{ borderRadius: "16px", border: "none" }}
        >
          <div
            className="modal-header"
            style={{
              background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
              color: "white",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <h5 className="modal-title fw-bold">
              Assign Doctor & Set Priority
            </h5>
            <button
              type="button"
              className="btn-close btn-close-white"
              onClick={onHide}
            ></button>
          </div>
          <div className="modal-body p-4">
            <div className="mb-3">
              <label className="form-label fw-semibold">Select Doctor *</label>
              <select
                className="form-select"
                value={assignData.doctorId}
                onChange={(e) =>
                  setAssignData({ ...assignData, doctorId: e.target.value })
                }
                style={{ borderRadius: "10px" }}
              >
                <option value="">Choose Doctor</option>
                {doctors.map((doc) => (
                  <option key={doc._id} value={doc._id}>
                    Dr. {doc.name}{" "}
                    {doc.specialization && `(${doc.specialization})`}
                  </option>
                ))}
              </select>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Date *</label>
                <input
                  type="date"
                  className="form-control"
                  value={assignData.date}
                  onChange={(e) =>
                    setAssignData({ ...assignData, date: e.target.value })
                  }
                  style={{ borderRadius: "10px" }}
                />
              </div>

              <div className="col-md-6 mb-3">
                <label className="form-label fw-semibold">Time *</label>
                <input
                  type="time"
                  className="form-control"
                  value={assignData.time}
                  onChange={(e) =>
                    setAssignData({ ...assignData, time: e.target.value })
                  }
                  style={{ borderRadius: "10px" }}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold">Priority Level *</label>
              <select
                className="form-select"
                value={assignData.priority}
                onChange={(e) =>
                  setAssignData({ ...assignData, priority: e.target.value })
                }
                style={{
                  borderRadius: "10px",
                  borderColor: getPriorityColor(assignData.priority),
                  borderWidth: "2px",
                }}
              >
                <option value="Normal">Normal</option>
                <option value="Urgent">Urgent</option>
                <option value="Most Urgent">Most Urgent</option>
              </select>
              <small className="text-muted mt-1 d-block">
                Priority determines waiting time and appointment order
              </small>
            </div>
            <div className="mb-3">
              <label className="form-label fw-semibold">
                Waiting Time (minutes) *
              </label>
              <input
                type="number"
                className="form-control"
                value={assignData.waitingTime || 30}
                onChange={(e) =>
                  setAssignData({
                    ...assignData,
                    waitingTime: parseInt(e.target.value) || 30,
                  })
                }
                min="0"
                placeholder="30"
                style={{ borderRadius: "10px" }}
              />
              <small className="text-muted mt-1 d-block">
                Estimated time patient will wait before seeing doctor
              </small>
            </div>

            {/* Priority Info Box */}
            <div
              className="alert mb-0"
              style={{
                background: `${getPriorityColor(assignData.priority)}15`,
                border: `1px solid ${getPriorityColor(assignData.priority)}50`,
                borderRadius: "10px",
              }}
            >
              <div className="d-flex align-items-center">
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    background: getPriorityColor(assignData.priority),
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "white",
                    fontWeight: "bold",
                    marginRight: "12px",
                  }}
                >
                  {assignData.priority === "Most Urgent"
                    ? "!"
                    : assignData.priority === "Urgent"
                    ? "⚠"
                    : "✓"}
                </div>
                <div>
                  <div
                    className="fw-semibold"
                    style={{ color: getPriorityColor(assignData.priority) }}
                  >
                    {assignData.priority}
                  </div>
                  <small className="text-muted">
                    {assignData.priority === "Most Urgent" &&
                      "Immediate attention required - 5 to 10 min wait"}
                    {assignData.priority === "Urgent" &&
                      "Priority case - 15 to 20 min wait"}
                    {assignData.priority === "Normal" &&
                      "Standard appointment - 30 to 45 min wait"}
                  </small>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="btn btn-secondary"
              onClick={onHide}
              style={{ borderRadius: "10px" }}
            >
              Cancel
            </button>
            <button
              className="btn btn-success"
              onClick={onAssign}
              disabled={loading}
              style={{ borderRadius: "10px" }}
            >
              Assign & Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssignDoctorModal;
